export class Kpi {

    title: string;
    value: number;
    total: number;

    colors: string[];
    icon: string;

    constructor(title: string, value: number, total: number) {
        this.title = title;
        this.value = value;
        this.total = total;

        this.colors = this.getColors();
        this.icon = this.getIcon();
    }

    /**
     * TODO give names / classes to this custom colors.
     */
    getColors(): string[] {
        switch (this.title) {
            case 'Connected devices':
                return ['#ECF9EE', '#37BB54']; // custom greens
            case 'Devices with warnings':
                return ['#FEF6E7', '#F59E0B']; // custom yellows
            case 'Devices with errors':
                return ['#FCEBED', '#DD2E44']; // custom reds
            case 'Open issues':
                return ['#CCCCFF', '#0000FF']; // custom blues
            default:
                return ['#E5E5E5', '#808080']; // custom grays
        }
    }

    getIcon() {
        switch (this.title) {
            case 'Connected devices':
                return 'mat_outline:cloud';
            case 'Devices with warnings':
                return 'mat_solid:warning';
            case 'Devices with errors':
                return 'mat_solid:error';
            case 'Open issues':
                return 'mat_outline:headset_mic';
            default:
                return 'mat_solid:brightness_1';
        }
    }
}
